<template>
    <div id="FilterSet" v-if='loadShow'>
        <NoticeBar
            class="topTitle"
            color="#F74040"
            background="#FFECE2"
            speed="50"
            :text='`勾选过滤后旺旺上有${titleTime}分钟未回复的此类型消息，将不再向您推送提醒`'
        />
        <div class="stroeList">
            <div class="listDiv">
                <div v-for="(item, index) in stroeList" :key="index" :class="item.active ?'titleActive' :''" @click="changeStroe(index, item.visitor_id)">
                    <p>{{item.visitor_nick}}</p>
                </div>
            </div>
            <div class="rightIcon">
                <i class="iconfont icon-you"></i>
                <i class="iconfont icon-you" style="margin-left:-2vw"></i>
            </div>
        </div>
        <div class="contentDiv">
            <div class="contentItem">
                <div class="itemList">
                    <div :class="_item.is_selected==1 ?'tagActive tagDiv' :'tagDiv'" v-for="(_item, _index) in dataList" :key="_index" @click="tagChoose( _index)">
                        <div class="chooseBtn" v-if="_item.is_selected==1">
                            <i class="iconfont icon-duihao1"></i>
                        </div>
                        <div class="chooseBtn" v-if="_item.is_selected!==1"></div>
                        <span>{{_item.type_name}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="footerBtn" @click="saveBtn">
                <p>保存设置</p>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast, NoticeBar } from 'vant';
export default {
    components: { Toast, NoticeBar },
    data() {
        return {
            loadShow: false,
            stroeList: [],
            dataList: {},
            filter_list: {},
            visitor_id: '',
            titleTime: 1
        }
    },
    mounted() {
        this.getDate()
        
    },
    methods: {
        getDate() {
            this.$store.dispatch('FilterSet/getFilterMsg',{}).then(res=>{ 
                this.filter_list = res.data.filter_list
                this.loadShow = true
                for(let i in res.data.shop_list) {
                    res.data.shop_list[i].active = false
                }
                res.data.shop_list[0].active = true
                this.dataList = this.filter_list[res.data.shop_list[0].visitor_id].filter_list
                this.visitor_id = res.data.shop_list[0].visitor_id
                this.titleTime = res.data.shop_list[0].remind_time_set
                
                this.stroeList = res.data.shop_list
            })
            
            this.$forceUpdate()
        },
        changeStroe(index, id) {
            for(let i in this.stroeList) {
                this.stroeList[i].active = false
            }
            this.stroeList[index].active = true
            this.dataList = this.filter_list[this.stroeList[index].visitor_id].filter_list
            this.visitor_id = this.stroeList[index].visitor_id
            this.titleTime = this.stroeList[index].remind_time_set
            
            this.$forceUpdate()
        },
        tagChoose( _index) {
            this.dataList[_index].is_selected = this.dataList[_index].is_selected==1 ?0 :1
            this.$forceUpdate()
        },
        saveBtn() {
            let arr = []
            let str = ''
            for(let i in this.dataList) {
                if(this.dataList[i].is_selected == 0) {
                    arr.push(this.dataList[i].id)
                }
            }
            for(let i in arr) {
                if(i < arr.length-1) {
                    str += `${arr[i]},`
                }else {
                    str += `${arr[i]}`
                }
            }
            let parame = {
                visitor_id: this.visitor_id,
                monitor_msg_ids: str
            }
            this.$store.dispatch('FilterSet/saveUnFilterMsg',parame).then(res=> {
                if(res.code == 1000) {
                    Toast('保存成功')
                    // setTimeout(()=> {
                    //     this.$router.push('MessageSwitch')
                    // },1000)
                }else {
                    Toast(res.message)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import './index.scss';
</style>